/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Export_Done_TitleInputs */

const en_us2_profile_editors_export_done_title = /** @type {(inputs: Profile_Editors_Export_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File ready`)
};

const pt_br2_profile_editors_export_done_title = /** @type {(inputs: Profile_Editors_Export_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo pronto`)
};

const es_419_profile_editors_export_done_title = /** @type {(inputs: Profile_Editors_Export_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo listo`)
};

const pt_pt2_profile_editors_export_done_title = /** @type {(inputs: Profile_Editors_Export_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ficheiro pronto`)
};

const fr_fr2_profile_editors_export_done_title = /** @type {(inputs: Profile_Editors_Export_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier prêt`)
};

const de_de2_profile_editors_export_done_title = /** @type {(inputs: Profile_Editors_Export_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei bereit`)
};

const it_it2_profile_editors_export_done_title = /** @type {(inputs: Profile_Editors_Export_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File pronto`)
};

/**
* | output |
* | --- |
* | "File ready" |
*
* @param {Profile_Editors_Export_Done_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_export_done_title = /** @type {((inputs?: Profile_Editors_Export_Done_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Export_Done_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_export_done_title(inputs)
	if (locale === "es-419") return es_419_profile_editors_export_done_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_export_done_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_export_done_title(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_export_done_title(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_export_done_title(inputs)
	return en_us2_profile_editors_export_done_title(inputs)
});
export { profile_editors_export_done_title as "profile-editors.export_done_title" }